import { Box, Button } from "@mui/material"
import { iconKey } from "@/common/globals"

import useIsMobile from "@/hooks/useIsMobile"
import useDialogState from "@/hooks/useDialogState"
import EventFilterDialog from "@/dialogs/EventFilterDialog"
import { useNavBarContext } from "@/contexts/NavBarContext"
import ReactGA from "react-ga4"
import { useGetMe } from "@/hooks/useGetMe"

export const FilterMenuButton = () => {
  const isMobile = useIsMobile()
  const { openDialog, ...dialogState } = useDialogState({})
  const { isHovered } = useNavBarContext()
  const { data: me } = useGetMe()

  const handleOpenDialog = () => {
    // Track filter menu button click
    ReactGA.event({
      category: "Filter",
      action: "Open filter menu",
      label: `User: ${me?.id ?? "guest"}`,
    })
    openDialog({})
  }

  return (
    <Box justifyContent="center" alignContent="center">
      <Button
        variant={isHovered ? "outlined" : "text"}
        sx={{
          height: isMobile ? "32px" : "56px",
          maxWidth: isMobile ? "32px" : "56px",
          minWidth: isMobile ? "32px" : "56px",
          borderRadius: "18px",
          padding: 0,
        }}
        aria-label="menu"
        aria-expanded="false"
        onClick={handleOpenDialog}
      >
        <img
          style={{
            width: isMobile ? "21px" : "24px",
          }}
          src={iconKey.filter}
          alt="Filter events"
          color="#7B7B7B"
        />
      </Button>
      <EventFilterDialog {...dialogState} />
    </Box>
  )
}
